import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DriverDepositeTransactionService {
  constructor(private http:HttpClient) { }

  driverDeposite(data:any){
    return this.http.post(environment.apiUrl+"driver/deposittransaction/get" , data);
  }
}



